import React, { useEffect } from 'react';
import MarketingPageLayout from '../../common/layout/MarketingPageLayout';
import { scrollPageTop } from '../../../utils/site';
import FeatureCardsSection from '../../common/marketing/FeatureCardsSection';
import FaqSectionBlock from '../../common/marketing/FaqSectionBlock';
import { getHomePage } from '../../../data/db';
import HomeSeo from './components/HomeSeo';
import HomeFestiveBanner from './components/HomeFestiveBanner';
import HomeProductSelectionSection from './components/HomeProductSelectionSection';
import './aboutProducts.css';

const AboutProducts = () => {
    useEffect(() => {
        scrollPageTop();
    }, []);

    const { seo, festiveBanner, hero, featuresSection, productSelection: rawProductSelection, faqSection } = getHomePage();
    const productSelection = { ...rawProductSelection, cards: rawProductSelection.cards.filter((card) => !card.hidden) };

    return (
        <>
            <HomeSeo seo={seo} productCards={productSelection.cards} faqItems={faqSection.items} shareImageKey={festiveBanner?.imageKey} />
            <MarketingPageLayout pageClassName="about-products-page">
                {festiveBanner ? <HomeFestiveBanner banner={festiveBanner} /> : null}
                <HomeProductSelectionSection intro={hero} productSelection={productSelection} />
                <FeatureCardsSection
                    sectionClassName="global-features"
                    header={{
                        wrapperClassName: 'section-header-centered',
                        subtitleClassName: 'section-subtitle',
                        titleClassName: 'section-title',
                        subtitle: featuresSection.subtitle,
                        title: featuresSection.title
                    }}
                    gridClassName="features-grid-custom"
                    cardClassName="feature-card-custom"
                    iconClassName="feature-icon-box"
                    items={featuresSection.items}
                />
                <FaqSectionBlock
                    sectionClassName="combined-faq"
                    header={{
                        wrapperClassName: 'section-header-centered',
                        subtitleClassName: 'section-subtitle',
                        titleClassName: 'section-title',
                        subtitle: faqSection.subtitle,
                        title: faqSection.title
                    }}
                    faqProps={{
                        items: faqSection.items,
                        listClassName: 'faq-grid',
                        itemClassName: 'faq-item',
                        questionClassName: 'faq-question',
                        iconClassName: 'faq-icon',
                        answerClassName: 'faq-answer',
                        icon: '+'
                    }}
                />
            </MarketingPageLayout>
        </>
    );
};

export default AboutProducts;
